import { Wrapper } from '@googlemaps/react-wrapper'
import { Map, MapProps } from './components/map'
import { cn } from '../../utils'

export interface OrMapProps extends MapProps {
  apiKey: string
  title?: string
  description?: string
  className?: string
}

export const OrMap = ({ title, description, apiKey, className, ...props }: OrMapProps) => (
  <div className={cn('w-full flex flex-col gap-8', className)}>
    {title || description ? (
      <div>
        {title && (
          <h2 className="text-neutrals-900 text-24 slg:text-32 font-medium font-heading leading-[1.3]">{title}</h2>
        )}
        {description && <p className="text-neutrals-700 slg:text-20">{description}</p>}
      </div>
    ) : null}
    <div className="h-[28.125rem] sm:h-[32.5rem] slg:h-[22rem] lg:h-[23rem]">
      <Wrapper apiKey={apiKey}>
        <Map {...props} />
      </Wrapper>
    </div>
  </div>
)
